export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  "https://gchat-r3-api.greatlabs.workers.dev";
export const DEFAULT_LANGUAGE = "pt-br";
export const DEFAULT_ID_WL = import.meta.env.VITE_ID_WL || "1";

export const POLLING_INTERVAL_INBOXES = 5000;
export const POLLING_INTERVAL_MESSAGES = 3000;

export function getAccountIdFromUrl(): string {
  // Check subdomain: conta123.greatchat.com -> "123"
  const hostname = window.location.hostname;
  const subdomainMatch = hostname.match(/^conta(\d+)\./);
  if (subdomainMatch) return subdomainMatch[1];

  // Check path: /a/123 -> "123"
  const pathMatch = window.location.pathname.match(/^\/a\/(\d+)/);
  if (pathMatch) return pathMatch[1];

  // Fallback for dev: use localStorage or default
  return localStorage.getItem("gchat_id_account") || "1";
}
